import { UserData } from '../../interfaces/users.interface';
import { createReducer, on } from '@ngrx/store';
import { loadUser, loadUserFailure, loadUserSuccess } from './user.actions';

export interface UserState {
  user: UserData | null;
  loading: boolean;
  error: any;
}

export const initialState: UserState = {
  user: null,
  loading: false,
  error: null
};

export const userReducer = createReducer(
  initialState,
  on(loadUser, (state) => ({ ...state, loading: true })),
  on(loadUserSuccess, (state, { user }) => ({ ...state, loading: false, user })),
  on(loadUserFailure, (state, { error }) => ({ ...state, loading: false, error }))
);
